const _ = require('lodash');

const emptyParams = {
    productId: undefined,
    recipeId: undefined,
    cardId: undefined,
    name: undefined
};

const idTypes = _.keys(emptyParams);

const DetailItemService = function DetailItemService($state, $q) {
    this.$state = $state;
    this.$q = $q;
};

DetailItemService.prototype.openCardDetail = function (card, id, stateParams) {
    this.cardIndex = card.position;
    this.selectedItemId = id;
    this.openCard = card;

    return stateParams !== undefined
        ? this._updateUrl(_.defaults(_.clone(emptyParams), stateParams))
        : this.$q.when(null);
};

DetailItemService.prototype.closeCardDetail = function () {
    this.cardIndex = undefined;
    this.cardId = undefined;
    this.selectedItemId = undefined;
    this.openCard = undefined;

    this.cardPerRow = undefined;

    // don't update the URL if there is a pending transition as otherwise we will break things like the back button
    return !this.$state.transition
        ? this._updateUrl(_.clone(emptyParams))
        : this.$q.when(null);
};

DetailItemService.prototype.containsCardId = function (object) {
    let isOpen = false;

    for (let i = 0; i < idTypes.length; i++) {
        const idType = idTypes[i];
        if (idType in object && object[idType] !== undefined && object[idType] !== null) {
            isOpen = true;
            break;
        }
    }

    return isOpen;
};

DetailItemService.prototype._updateUrl = function (stateParams) {
    return this.$state.transitionTo(this.$state.$current.self.name, stateParams, { location: true, inherit: true, notify: false });
};

DetailItemService.prototype.getOpenCardData = function () {
    return (this.openCard === null || this.openCard === undefined) ? undefined : this.openCard.data;
};

module.exports = DetailItemService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/detail/card-detail-service.js
 **/